import { ref } from 'vue';

export const authState = {
  userName: ref('Guest'),
  showLoginPopup: ref(false),
  isAuthenticated: ref(false),
  resetPasswordToken: ref<string | null>(null),
  mode: ref<'login' | 'forgotPassword' | 'resetPassword'>('login'),
  hasCheckedAuth: ref(false),
  isSharedChatView: ref(false),
};
